exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/system/company_mgr.page.css
// module id = ../../../../../src/app/page/system/company_mgr.page.css
// module chunks = 1